import {
  SHOW_MODAL_GHI_CHU_CHO_VAY,
  POST_GHI_CHU_CHO_VAY,
  POST_GHI_CHU_CHO_VAY_SUCCESS,
  POST_GHI_CHU_CHO_VAY_FAILURE,
  DELETE_GHI_CHU_CHO_VAY,
  DELETE_GHI_CHU_CHO_VAY_SUCCESS,
  DELETE_GHI_CHU_CHO_VAY_FAILURE,
  SET_LOAD_GHI_CHU_CHO_VAY,
} from "./actionTypes";

export const showModalGhiChuChoVay = () => ({
  type: SHOW_MODAL_GHI_CHU_CHO_VAY,
});

export const postGhiChuChoVay = (dataPost) => ({
  type: POST_GHI_CHU_CHO_VAY,
  dataPost,
});

export const postGhiChuChoVaySuccess = (data) => ({
  type: POST_GHI_CHU_CHO_VAY_SUCCESS,
  payload: data,
});

export const postGhiChuChoVayFailure = () => ({
  type: POST_GHI_CHU_CHO_VAY_FAILURE,
});

export const deleteGhiChuChoVay = (dataPost) => ({
  type: DELETE_GHI_CHU_CHO_VAY,
  dataPost,
});

export const deleteGhiChuChoVaySuccess = (data) => ({
  type: DELETE_GHI_CHU_CHO_VAY_SUCCESS,
  payload: data,
});

export const deleteGhiChuChoVayFailure = () => ({
  type: DELETE_GHI_CHU_CHO_VAY_FAILURE,
});
export const setLoadGhiChu = () => ({
  type: SET_LOAD_GHI_CHU_CHO_VAY,
});
